"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../shared/controllers/BaseController");
var DlgKeyValueEditorCtl = /** @class */ (function (_super) {
    __extends(DlgKeyValueEditorCtl, _super);
    function DlgKeyValueEditorCtl() {
        return _super.call(this, true) || this;
    }
    DlgKeyValueEditorCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            messageKey: "",
            dialogTitle: "",
            messageVal: "",
            visible: false,
        };
    };
    DlgKeyValueEditorCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgKeyValueEditorCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgKeyValueEditorCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgKeyValueEditorCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgKeyValueEditorCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgKeyValueEditorCtl.prototype, "onYesClick", {
        get: function () {
            return this.DATA.onYes;
        },
        enumerable: true,
        configurable: true
    });
    DlgKeyValueEditorCtl.prototype.SetDialogTitle = function (title) {
        this.DATA.dialogTitle = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgKeyValueEditorCtl.prototype, "dialogTitle", {
        get: function () {
            return this.DATA.dialogTitle;
        },
        enumerable: true,
        configurable: true
    });
    DlgKeyValueEditorCtl.prototype.SetMessageKey = function (key) {
        this.DATA.messageKey = key;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgKeyValueEditorCtl.prototype, "messageKey", {
        get: function () {
            return this.DATA.messageKey;
        },
        enumerable: true,
        configurable: true
    });
    DlgKeyValueEditorCtl.prototype.SetMessageVal = function (val) {
        this.DATA.messageVal = val;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgKeyValueEditorCtl.prototype, "messageVal", {
        get: function () {
            return this.DATA.messageVal;
        },
        enumerable: true,
        configurable: true
    });
    return DlgKeyValueEditorCtl;
}(BaseController_1.BaseController));
exports.DlgKeyValueEditorCtl = DlgKeyValueEditorCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgKeyValueEditorCtl.ts
// module id = 918
// module chunks = 0